export default {
  model () {
    return {
      billTo: null,
      dealerId: null,
      shipTo: null,
      name: null
    }
  },
  rules (model) {
    return {
      dealerId: {required: true, message: 'El distribuidor es requerido', trigger: 'change'},
      shipTo: {required: true, message: 'La sucursal es requerida', trigger: 'blur'},
      name: {required: true, message: 'Escriba su nombre por favor', trigger: 'blur'}
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/login.model.js